export default __webpack_public_path__ + "locales/sr-Latn-RS/Errors.json?hash=69c3a5ec6273d29da060d8dfc6226ef6";